<template>
    <div class="container remove-padding-margin">
        <div class="fixed-top fixed-judul">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-3 col-sm-3 col-3 remove-padding">
                    <img src="../../assets/gambar/back-blue.svg" alt="" @click="back()">
                </div>
                <div class="col-md-6 col-sm-6 col-6 text-center remove-padding" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                    Data Akun</div>
                <div class="col-md-3 col-sm-3 col-3 remove-padding">
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 pad-top-66">
                    <div class="animasi-card  bg-transparent d-flex mar-bottom-16">
                        <div class="font-16 status-login" style="padding: 2px 10px;color: #206CFF">Langkah <span class="font-weight-bold">{{isWebview() ? '2/3' : '2/4' }}</span></div>
                    </div>
                    <div class="font-weight-bold text-createstaff">

                    </div>
                    <div class="font-16 color-0000 mar-bot-12 letter-space-002 line-height-25">
                        Berikut adalah data login karyawan Anda untuk masuk di aplikasi kasir atau produksi.
                    </div>
                    <form action="">
                        <div class="form-group">
                            <div>
                                <label class="remove-margin require color-6f7 font-14 line-height-21 letter-space-002" for="username">Username</label>
                                <input type="text" class="form-control inputs" id="username" autocomplete="off"
                                       aria-describedby="emailHelp" placeholder="EX:Harmania_Sidoarjo19" v-model="datadatastaff.username" v-on:keyup="inputusername">
	                            <ErrorMessage class="error" label="Username" :validation="$v.datadatastaff.username"></ErrorMessage>
                            </div>
                            <div>
                                <label class="remove-margin require mar-top-12 font-14 line-height-21 letter-space-002 color-6f7" for="password">Kata sandi</label>
                                <input type="password" class="form-control inputs" id="password" autocomplete="off"
                                       aria-describedby="emailHelp" placeholder="" v-model="datadatastaff.password" v-on:keyup="inputpass">
                                <span toggle="#password-field1" id="password-field1" v-on:click="changeViewPass1"
                                      class="fa fa-eye field-icon toggle-password"></span>
                                <div class="font-12 text-small mar-top-5">Minimal 8 karakter dengan kombinasi huruf dan angka</div>
	                            <ErrorMessage class="error" label="Password" :validation="$v.datadatastaff.password"></ErrorMessage>
                            </div>
                            <div class="mar-top-16">
                                <label class="require color-6f7 font-14 mar-bot-4 font-14 line-height-21 letter-space-002" for="confirmpass">Ulangi kata sandi</label>
                                <input type="password" id="confirmpass" autocomplete="off" class="form-control inputs" placeholder="" v-model="datadatastaff.confirm_password" @keyup="inputpass1">
                                <span toggle="#password-field2" id="password-field2" v-on:click="changeViewPass"
                                      class="fa fa-eye field-icon toggle-password"></span>
	                            <ErrorMessage class="error" label="Password" :validation="$v.datadatastaff.confirm_password"></ErrorMessage>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="button-lanjut ">
                    <button class="btn btn-login btn-long remove-margin" id="btnNextUsername" @click="matchpassword">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="datadatastaff.isClickedstaffakun === true"></span><span id="textBtnUsername">Berikutnya</span>
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {minLength, sameAs, required} from "vuelidate/lib/validators";

    export default {
        name: "DataStaff",
        props: ["datadatastaff"],
	    components: { ErrorMessage },
        mounted(){
          this.cekvalidasi()
        },
	    validations: {
		    datadatastaff: {
		    	username: {
		    		required,
				    minLength: minLength(2),
			    },
			    password: {
		    		required,
				    minLength: minLength(8),
			    },
			    confirm_password: {
		    		required,
				    minLength: minLength(8),
				    sameAsPassword: sameAs("password"),
			    }
		    }
	    },
        methods:{
            back(){
                this.$emit("showcreatestaff")
            },
            next(){
                if (this.isWebview()) this.$emit("showdatagaji")
                else this.$emit("showdatapekerjaan")
            },
            async checkusername(){
                this.datadatastaff.isClickedstaffakun = true
                $('#textBtnUsername').hide()
                $('#btnNextUsername').prop('disabled', true);
                try {
                    const response = await this.$axios.get(this.$CEK_USERNAME_KARYAWAN + '?username='+ this.datadatastaff.username, this.datadatastaff.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.next()
                            this.datadatastaff.isClickedstaffakun = false
                            $('#textBtnUsername').show()
                            $('#btnNextUsername').prop('disabled', false);
                        }else{
                        	this.$toast.error(response.data.msg)
                            this.datadatastaff.isClickedstaffakun = false
                            $('#textBtnUsername').show()
                            $('#btnNextUsername').prop('disabled', false);
                        }
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                
	                this.datadatastaff.isClickedstaffakun = false
	                $('#textBtnUsername').show()
	                $('#btnNextUsername').prop('disabled', false);
                }
            },
            inputpass(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z]+/, '');
                this.datadatastaff.password = number;
                this.cekvalidasi()
                this.combinationpass()
            },

            inputpass1(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z]+/, '');
                this.confirm_password = number;
                this.cekvalidasi()
                this.combinationpass1()
            },

            changeViewPass(event) {
                if ($('#confirmpass').attr("type") == "password") {
                    $('#password-field2').removeClass('fa fa-eye');
                    $('#password-field2').addClass('fa fa-eye fa-eye-slash');
                    $('#confirmpass').attr("type", "text");
                } else {
                    $('#password-field2').removeClass('fa fa-eye fa-eye-slash');
                    $('#password-field2').addClass('fa fa-eye');
                    $('#confirmpass').attr("type", "password");
                }
            },

            changeViewPass1(event) {
                if ($('#password').attr("type") == "password") {
                    $('#password-field1').removeClass('fa fa-eye');
                    $('#password-field1').addClass('fa fa-eye fa-eye-slash');
                    $('#password').attr("type", "text");
                } else {
                    $('#password-field1').removeClass('fa fa-eye fa-eye-slash');
                    $('#password-field1').addClass('fa fa-eye');
                    $('#password').attr("type", "password");
                }
            },

            inputusername(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z.,'-]+/, '');
                this.datadatastaff.username = number;
                this.cekvalidasi()
            },
            combinationpass(){
                if(this.datadatastaff.password !== '') {
                    var numeric = /[0-9]/;
                    var alphabeth = /[A-Za-z]/
                    if(!numeric.test(this.datadatastaff.password) || !alphabeth.test(this.datadatastaff.password)) {
                        // $('#btnNextUsername').prop('disabled', true);
                        return true;
                    }
                }else {
                    // $('#btnNextUsername').prop('disabled', false);
                    return false
                }

            },

            combinationpass1(){
                if(this.datadatastaff.confirm_password !== '') {
	                var numeric = /[0-9]/;
	                var alphabeth = /[A-Za-z]/
                    if(!numeric.test(this.datadatastaff.confirm_password) || !alphabeth.test(this.datadatastaff.confirm_password)) {
                        // $('#btnNextUsername').prop('disabled', true);
                        return true;
                    }
                }else {
                    // $('#btnNextUsername').prop('disabled', false);
                    return false
                }

            },
            cekvalidasi(){
            	return
                var staffusername = this.datadatastaff.username;
                var staffpass = this.datadatastaff.password;
                var staffpasscon = this.datadatastaff.confirm_password;
                var stringstaffpass = staffpass.toString()
                var stringstaffpasscon = staffpasscon.toString()
                var lenPass = staffusername.length;
                if (lenPass >= 2 && (stringstaffpass.length >= 8)&& (stringstaffpasscon.length >= 8)) {
                    $('#btnNextUsername').prop('disabled', false);
                } else {
                    // $('#btnNextUsername').prop('disabled', false);
                    $('#btnNextUsername').prop('disabled', true);
                }
            },

	        errorValidation() {
		        this.$v.datadatastaff.$touch()
            	return this.$v.datadatastaff.$invalid
	        },
            matchpassword(){
            	if (this.errorValidation()) {
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
		            return
	            }
            	if (this.combinationpass() && this.combinationpass1()) {
		            this.$toast.error("Password harus mengandung kombinasi huruf dan angka")
            		return
	            }
                var matchpass = this.datadatastaff.password;
                if (matchpass === this.datadatastaff.confirm_password && matchpass !== ''){
                    // $('#btnbuatsandi').prop('disabled', false);
                    this.checkusername()
                }
                else {
                	this.$toast.error('Kata Sandi yang anda masukkan tidak sesuai!')
                }
            },
        }
    }
</script>

<style scoped>
    .text-createstaff{
        line-height: 21px;
        align-items: center;
        letter-spacing: -0.01em;
        color: #333333;
    }

    .set-small-text{
        line-height: 140%;
        letter-spacing: -0.02em;
    }

    .text-small{
        line-height: 18px;
        letter-spacing: -0.02em;
        color: #6F7287;
    }

    .status-login {
        font-size: 14px;
        background: #E2F0FF;
        border-radius: 50px;
        color: #5F95FF;
        padding: 2px 10px;
    }
</style>